import { render, staticRenderFns } from "./LoadingMask.vue?vue&type=template&id=67c918fb&scoped=true&"
import script from "./LoadingMask.vue?vue&type=script&lang=js&"
export * from "./LoadingMask.vue?vue&type=script&lang=js&"
import style0 from "./LoadingMask.vue?vue&type=style&index=0&id=67c918fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c918fb",
  null
  
)

export default component.exports